export default __webpack_public_path__ + "static/poster-adf801d964f1667f380460e3d034470f.png";